import React from "react";

import config from "../../../config/config";

import "./ReferenceTables.scss";

const ReferenceTables2022 = () => {
  return (
    <>
      <h1>Reference Tables</h1>
      <section className="ref-tables-section">
        <ul>
          <li>
            <span className="ref-tables-volume">Volume 1 - CKD:</span>
            <ul>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=CKD_Ref_B_Prevalence_2022`}
                >
                  B. Prevalence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=CKD_Ref_K_Expenditures_2022`}
                >
                  K. Expenditures
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="ref-tables-volume">Volume 2 - ESRD:</span>
            <ul>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_A_Incidence_2022`}
                >
                  A. Incidence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_B_Prevalence_2022`}
                >
                  B. Prevalence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_C_PatientChars_2022`}
                >
                  C. Patient Characteristics
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_D_Modality_2022`}
                >
                  D. Treatment Modalities
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_E_transplantProcess_2022`}
                >
                  E. Transplantation: Process
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_F_TransplantOutcomes_2022`}
                >
                  F. Transplantation: Outcomes
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_G_Hospitalization_2022`}
                >
                  G. Morbidity and Hospitalization
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_H_Mortality_2022`}
                >
                  H. Mortality and Causes of Death
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_I_Survival_2022`}
                >
                  I. Patient Survival
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_J_Providers_2022`}
                >
                  J. Provider Characteristics
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_K_Costs_2022`}
                >
                  K. Expenditures for ESRD Patients
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_L_VascularAccess_2022`}
                >
                  L. Vascular Access
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_M_Census_2022`}
                >
                  M. Census Populations
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=ESRD_Ref_N_International_2022`}
                >
                  N. International Comparisons
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2022&referenceTable=Reference Table Methods`}
                >
                  Analytical Methods
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </>
  );
};

export default ReferenceTables2022;
